import { Directive } from '@angular/core';
@Directive({
  selector: '[fLogoContainer]',
  standalone: false
})
export class LogoContainerDirective {}
